export default __webpack_public_path__ + "static/assets/00587c9232d07371b8d94153a2150e8d.png";